export default {
    //apiUrl: "https://localhost:44316/api",
    //apiUrl: "https://digital-kobi-operation-api.finekra.com/api",
    apiUrl: "https://operation-api.isimicin.co/api",
    //supportPanelImgUrl: "https://localhost:44327",
    supportPanelImgUrl: "https://api.isimicin.co",
}